<script setup lang="ts">
import { useVuelidate } from '@vuelidate/core'
import { required, integer, minLength, maxLength, sameAs, helpers } from '@vuelidate/validators'

import Key from '@material-symbols/svg-400/rounded/key.svg'
import ChevronRight from '@material-symbols/svg-400/rounded/chevron_right.svg'
import TextInput from './form_inputs/TextInput.vue'

import { state } from '../state'
import { computed } from 'vue'

const emit = defineEmits<{
  (event: 'onClickNext'): void
}>()

const rules = computed(() => ({
  pinCode: { required, integer, minSize: minLength(4), maxSize: maxLength(8) },
  pinCodeConfirm: {
    required,
    integer,
    minSize: minLength(4),
    maxSize: maxLength(8),
    sameAs: helpers.withMessage('PINs do not match', sameAs(state.pinCode))
  }
}))

const v$ = useVuelidate(rules, state)

async function onSubmit() {
  if (await v$.value.$validate()) {
    emit('onClickNext')
  }
}
</script>

<template>
  <form @submit.prevent @submit="onSubmit">
    <p class="my-4 dark:text-gray-300">
      Please enter a PIN as protection, in case someone gets a hold of your barcode. The PIN you
      enter here, together with the barcode will be required in order to access your test result.
    </p>
    <div class="flex items-center justify-between space-x-6">
      <div>
        <TextInput
          type="password"
          id="pinCode"
          v-model="state.pinCode"
          :icon="Key"
          label="PIN"
          placeholder="A secure PIN"
          :errors="v$.pinCode.$errors.map<any>((e) => e.$message)"
        />
      </div>
      <div>
        <TextInput
          type="password"
          id="pinCodeConfirm"
          v-model="state.pinCodeConfirm"
          :icon="Key"
          label="PIN confirmation"
          placeholder="A secure PIN"
          :errors="v$.pinCodeConfirm.$errors.map<any>((e) => e.$message)"
        />
      </div>
    </div>
    <div class="flex justify-end my-4 text-sm">
      <button class="btn-next" type="submit">
        Next
        <ChevronRight class="w-6 h-6 ml-2" />
      </button>
    </div>
  </form>
</template>
